<!-- 海外ip提醒 -->
<template>
  <div v-if="showTip" class="oversea-tip row">
    <img :src="ALERT_ICON" />
    <div>{{overseaInfo.delayText}}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'oversea-tip',

  props: {

  },

  data() {
    return {
      ALERT_ICON: 'https://j5.dfcfw.com/sc/image/202202/20220225093517.png',
    };
  },

  computed: {
    ...mapState('overseaInfo', ['isOversea', 'overseaInfo']),
    showTip() {
      return this.isOversea && !this.$isEmpty(this.overseaInfo?.delayText);
    },
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.oversea-tip {
  width: 100%;
  background-color: #FDF8F0;
  border: 1px solid #F7E6D3;
  margin: 24px 0;
  padding: 24px;
  box-sizing: border-box;
  border-radius: 12px;
  color: #ff4400;
  font-size: 28px;
  img {
    width: 26px;
    height: 26px;
    margin-right: 24px;
  }
}
</style>
